import { isFrenchCompany } from '@features/companies/utils/isFrenchCompany'
import { Company, FrenchCompany } from '@modules-deprecated/app/companies/types'

const baseDetailedFields = ['city', 'country', 'name', 'street', 'zipcode']
const extendedDetailedFields = [...baseDetailedFields, 'number']

export const isDetailedCompany = (company: Partial<Company> | Partial<FrenchCompany>): boolean => {
  const fields = isFrenchCompany(company) ? baseDetailedFields : extendedDetailedFields
  return fields.every((field: string) => field in company)
}
